import React from 'react'
import { Skeleton } from '@mui/material'
import { Tr } from '../../../../../../layouts/tableLayout/_tr'
import { Td } from '../../../../../../layouts/tableLayout/_td'
import { Text } from '../../../../../../common/text'
import { Input } from 'common/form/input'
import useCommissionTable from '../../hook/useCommissionTable'
import styled from 'styled-components'
import { formatNumber } from 'util/formatNumber'

const TableBody = () => {
  const { displayList, displayLoading, handleChangeCommission } = useCommissionTable()

  return (
    <StyledTBody>
      {displayLoading ? (
        Array.from(Array(5), (e, i) => (
          <CommissionPlaceholder key={i}/>
        ))
      ) : displayList?.length > 0 ? (
        displayList.map((item, key) => <CommissionTr key={item.id} stt={key} data={item} handleChange={handleChangeCommission}/>)
      ) : (
        <CommissionEmpty list={displayList}/>
      )}
    </StyledTBody>
  )
}

export default TableBody

const CommissionPlaceholder = ({ ...props }) => {
  return (
    <Tr {...props} className="create-commission-table">
      {Array.from(Array(6), (e, i) => (
        <Td key={i} className="create-commission-table_cell" data-type="td">
          <Skeleton
            sx={{
              width: '100%',
              height: 33,
              background:
                'linear-gradient(0deg, rgba(244, 247, 252, 0.98), rgba(244, 247, 252, 0.98)), #00081D;',
            }}
          />
        </Td>
      ))}
    </Tr>
  )
}

const CommissionEmpty = ({ list, ...props }) => {
  return (
    <StyledCommissionEmpty {...props}>
      <img
        className="create-commission-table-empty__banner"
        src="/img/order/order-empty.png"
        alt="empty"
      />
      <Text as="b" color="#7C88A6" style={{ marginBottom: 16 }}>
        Không tìm thấy danh mục
      </Text>
    </StyledCommissionEmpty>
  )
}

const CommissionTr = ({ data, stt, handleChange, ...props }) => {
  return (
    <>
      <Tr {...props} className="create-commission-table__row">
        <Td className="create-commission-table__cell" data-type="td">
          {+stt + 1}
        </Td>
        <Td className="create-commission-table__cell" data-type="td">
            <Text as={'p'}>{data?.title || '---'}</Text>
        </Td>
        <Td className="create-commission-table__cell" data-type="td">
          <Text>{formatNumber(data?.teacher_commission_manager || 0)}%</Text>
        </Td>
        <Td className="create-commission-table__cell" data-type="td">
            <div className='input-commission'>
                <Input 
                    icon={'%'} 
                    value={data?.teacher_commission_principal} 
                    onChange={e => handleChange({field: 'teacher_commission_principal', equal: 'teacher_commission_manager', item: 'teacher_commission_rate', value: e.target.value}, data)}
                    validateType={data?.errorMessageTeacher ? "danger" : "default"}
                    validateText={data?.errorMessageTeacher ? data?.errorMessageTeacher : ""}
                />
            </div>
        </Td>
      </Tr>
    </>
  )
}

export const StyledTBody = styled.div`
  .create-commission-table {
    &__loading {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 100;

      width: 100vw;
      height: 100vh;

      display: flex;
      align-items: center;
      justify-content: center;

      background: rgba(0, 0, 0, 0.25);
    }

    &__row {
      &:hover {
        .create-commission-table__delete {
          display: block;
        }
        .create-commission-table__edit {
          display: block;
        }
      }
    }

    &__cell {
      cursor: pointer;
      display: flex;
      justify-content: left;
      align-items: center;
      &[data-menu='true'] {
        position: relative;
      }

      &:nth-child(1) {
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &:nth-child(2) {
        flex: 1;
        display: flex;
        align-items: center;
      }

      &:nth-child(3) {
        width: 15%;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      &:nth-child(4) {
        width: 15%;
        align-items: center;
        justify-content: center;
        .input-commission {
            width: 50%;
            
            .input__validate {
                width: max-content !important;
            }
        }
      }
    }
}
`
export const StyledCommissionEmpty = styled.div`
  min-height: calc(100vh - 430px);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #fff;

  .principal-empty__banner {
    width: 133px;
    height: 133px;
    margin-bottom: 16px;

    object-fit: contain;
    object-position: center;
  }
`
